import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PrequalificationState {
  isNeedToUpdateBorrowerInLos: boolean;
  isNeedToUpdateBorrowerEmailInLos: boolean;
  isNeedToClearLoanInformation: boolean;
  isContractorNameInputDisabled: boolean;
  isContractorInfoCheckboxChecked: boolean;
  confirmBorrowerEmail: string;
  confirmCoborrowerEmail: string;
  isBorrowerAuthorized: boolean;
}

const initialState: PrequalificationState = {
  isNeedToUpdateBorrowerInLos: false,
  isNeedToUpdateBorrowerEmailInLos: false,
  isNeedToClearLoanInformation: false,
  isContractorNameInputDisabled: false,
  isContractorInfoCheckboxChecked: false,
  confirmBorrowerEmail: '',
  confirmCoborrowerEmail: '',
  isBorrowerAuthorized: false,
};

const prequalificationPortal = createSlice({
  name: 'prequalificationPortal',
  initialState,
  reducers: {
    setPrequalificationPortal: (state, { payload }: PayloadAction<Partial<PrequalificationState>>) => {
      Object.assign(state, payload);
    },
    clearPrequalificationPortal: () => initialState,
  },
});

export const { setPrequalificationPortal, clearPrequalificationPortal } = prequalificationPortal.actions;
export default prequalificationPortal.reducer;
